import { render, staticRenderFns } from "./gCustomTabbar.vue?vue&type=template&id=02b8dd66&scoped=true"
import script from "./gCustomTabbar.vue?vue&type=script&lang=js"
export * from "./gCustomTabbar.vue?vue&type=script&lang=js"
import style0 from "./gCustomTabbar.vue?vue&type=style&index=0&id=02b8dd66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b8dd66",
  null
  
)

export default component.exports